import { RawSchema } from '@principle-theorem/editor';
import { INotificationContextRenderer } from '@principle-theorem/notifications';
import { NotificationType } from '@principle-theorem/principle-core/interfaces';
import { AddedTaskContextRenderer } from './context-renderers/added-task';
import { CompletedTaskContextRenderer } from './context-renderers/completed-task';
import { PatientBookedAppointmentContextRenderer } from './context-renderers/patient-booked-appointment';
import { PatientCancelledAppointmentContextRenderer } from './context-renderers/patient-cancelled-appointment';
import { PatientRescheduledAppointmentContextRenderer } from './context-renderers/patient-rescheduled-appointment';
import { ReopenedTaskContextRenderer } from './context-renderers/reopened-task';
import { StafferBookedAppointmentContextRenderer } from './context-renderers/staffer-booked-appointment';
import { StafferCancelledAppointmentContextRenderer } from './context-renderers/staffer-cancelled-appointment';
import { StafferRescheduledAppointmentContextRenderer } from './context-renderers/staffer-rescheduled-appointment';
import { TaskMentionedUserContextRenderer } from './context-renderers/task-mentioned-user';

export const NOTIFICATION_PROVIDERS: INotificationContextRenderer<
  RawSchema,
  NotificationType
>[] = [
  new PatientBookedAppointmentContextRenderer(),
  new StafferBookedAppointmentContextRenderer(),
  new PatientRescheduledAppointmentContextRenderer(),
  new StafferRescheduledAppointmentContextRenderer(),
  new PatientCancelledAppointmentContextRenderer(),
  new StafferCancelledAppointmentContextRenderer(),
  new TaskMentionedUserContextRenderer(),
  new CompletedTaskContextRenderer(),
  new ReopenedTaskContextRenderer(),
  new AddedTaskContextRenderer(),
];
